"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var JapanOverview2 = function JapanOverview2(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.408 3.016C14.136 3.016 9.888 3.16 5.664 3.448L6.072 5.92C9.768 5.656 13.824 5.536 18.264 5.536L18.408 3.016ZM7.08 10.288C5.976 12.184 5.424 13.744 5.424 14.944C5.424 16.48 6.12 17.584 7.56 18.28C8.904 18.928 10.968 19.264 13.776 19.264C15.024 19.264 16.872 19.168 19.32 18.976L19.176 16.408C17.232 16.648 15.432 16.768 13.776 16.768C12 16.768 10.632 16.624 9.72 16.336C8.64 16 8.112 15.496 8.112 14.8C8.112 13.984 8.568 12.88 9.504 11.488L7.08 10.288ZM1.584 0.447999C0.6 4.12 0.12 7.72 0.12 11.248C0.12 14.56 0.672 17.56 1.776 20.272L4.224 19.384C3.24 17.008 2.76 14.296 2.76 11.248C2.76 7.864 3.216 4.456 4.128 1.048L1.584 0.447999Z",
    fill: fill
  }));
};
JapanOverview2.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
JapanOverview2.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = JapanOverview2;